import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import Button from 'components/Button/Button';
import classes from '../InCallModal/InCallModal.module.scss';
import { hooks } from '@lifesize/clients.sdk';

const EndCallForAll = (props) => {
  const {
    isFullyConnected,
    isMeeting,
    isRemoteModerator,
    isModerator,
    isAgentRole,
    onCancelClicked,
    onEndCallClicked,
    onKickAllClicked
  } = props;
  const canKickAll = hooks.useCanCurrentUserKickAll();

  const renderPrompt = () => {
    if (isRemoteModerator) {
      return (
        <div className={classes.modalContent}>
          <FormattedMessage
            id="components.endCallForAllModal.remoteModerator"
            defaultMessage="Are you sure you want to end the meeting for everyone?"
          />
        </div>
      );
    } else if (isModerator || isAgentRole) {
      return (
        <div className={classes.modalContent}>
          <FormattedMessage
            id="components.endCallForAllModal.message"
            defaultMessage="Would you like to leave the meeting or end the meeting for everyone?"
          />
        </div>
      );
    } else if (isMeeting) {
      return (
        <div className={classes.modalContent}>
          <FormattedMessage
            id="components.endCallForAllModal.nonModHeader"
            defaultMessage="Would you like to leave the meeting?"
          />
        </div>
      );
    }
    return (
      <div className={classes.modalContent}>
        <FormattedMessage
          id="components.endCallForAllModal.p2pHeader"
          defaultMessage="Would you like to end the call?"
        />
      </div>
    );
  };

  return (
    <div className={classes.modal}>
      <header>
        <h3>
          {isMeeting && !isRemoteModerator ? (
            <FormattedMessage id="components.endCallForAllModal.title" defaultMessage="Leave Meeting" />
          ) : (
            <FormattedMessage id="components.endCallForAllModal.p2pTitle" defaultMessage="End Call" />
          )}
        </h3>
      </header>
      {renderPrompt()}
      <div className={classes.buttonBlock}>
        {!isRemoteModerator && (
          <Button kind="primary" onClick={onEndCallClicked} dataAttrs={{ 'data-testid': 'leave-meeting-btn' }}>
            {isMeeting || isAgentRole ? (
              <FormattedMessage id="components.endCallForAllModal.endCall" defaultMessage="Leave Meeting" />
            ) : (
              <FormattedMessage id="components.endCallForAllModal.p2pEndCall" defaultMessage="End Call" />
            )}
          </Button>
        )}
        {(canKickAll || isAgentRole) && (
          <Button
            kind={isRemoteModerator ? 'primary' : 'secondary'}
            onClick={onKickAllClicked}
            disabled={!isFullyConnected && !isRemoteModerator}
            dataAttrs={{ 'data-testid': 'end-meeting-btn' }}
          >
            <FormattedMessage id="components.endCallForAllModal.kickCall" defaultMessage="End Meeting" />
          </Button>
        )}
        <Button kind="secondary" onClick={onCancelClicked} dataAttrs={{ 'data-testid': 'cancel-leave-meeting-btn' }}>
          <FormattedMessage id="components.endCallForAllModal.cancel" defaultMessage="Cancel" />
        </Button>
      </div>
    </div>
  );
};

export default injectIntl(EndCallForAll);

EndCallForAll.propTypes = {
  isFullyConnected: PT.bool,
  isMeeting: PT.bool,
  isModerator: PT.bool,
  isRemoteModerator: PT.bool,
  isAgentRole: PT.bool,
  onCancelClicked: PT.func.isRequired,
  onEndCallClicked: PT.func.isRequired,
  onKickAllClicked: PT.func.isRequired
};
